export const languages = {
  'pt-br': 'PT',
  'en': 'EN',
  'es': 'ES',
  'fr': 'FR',
  'zh': 'ZH',
  'hi': 'HI',
  'ar': 'AR',
  'bn': 'BN',
  'ru': 'RU',
  'ja': 'JA',
} as const;

export type Locale = keyof typeof languages;
export const defaultLocale: Locale = 'pt-br';

export const ui = {
  'pt-br': {
    'nav.status': 'Aceitando novas parcerias',
    'nav.cta': 'Agendar uma call',
    'hero.tag': 'Tecnologia para creators',
    'hero.h1.a': 'Transformamos audiência',
    'hero.h1.em': 'em software.',
    'hero.lead': 'A Hook identifica a oportunidade de SaaS no seu nicho, constrói o produto e opera tudo — em parceria com você.',
    'hero.cta': 'Agendar uma call de discovery',
    'hero.meta': '30 min · sem compromisso',
    'portfolio.label': 'Portfólio',
    'portfolio.h2.a': 'Produtos no ar,',
    'portfolio.h2.em': 'operando agora.',
    'product.papomaterno.tag': 'Comunidade e ferramentas para mães acompanharem sua jornada, tirarem dúvidas e trocarem experiências.',
    'product.beluzi.tag': 'Plataforma de bem-estar e rituais diários, com prática guiada e acompanhamento contínuo.',
    'product.personalburn.tag': 'Treino, nutrição e progresso reunidos em um só lugar — construído com personal trainers, para personal trainers.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'Screenshot em breve',
    'manifesto.label': 'Como trabalhamos',
    'manifesto.h2.a': 'Parceria,',
    'manifesto.h2.em': 'não serviço.',
    'manifesto.body': 'A Hook não cobra pelo desenvolvimento. Construímos o produto, cuidamos da infraestrutura e operamos o SaaS junto com você — em troca de 50% da receita recorrente gerada. Só ganhamos quando você ganha.',
    'manifesto.body.strong': 'Construímos o produto, cuidamos da infraestrutura e operamos o SaaS junto com você',
    'manifesto.sig': '— uma empresa Prisma Tech, desde 2022',
    'final.h2.a': 'Os melhores produtos nascem da combinação certa entre audiência e',
    'final.h2.em': 'tecnologia.',
    'final.body': 'Se você tem um nicho engajado e quer entender se existe uma oportunidade aqui, a gente reserva 30 minutos para uma conversa.',
    'final.cta': 'Agendar uma call',
    'final.disclaimer': 'Sem compromisso. Sem pitch.',
    'footer.tagline': 'Uma empresa Prisma Tech.',
    'footer.copy': '© hook',
    'meta.title': 'hook — Transformamos audiência em software',
    'meta.description': 'A Hook identifica a oportunidade de SaaS no seu nicho, constrói o produto e opera tudo — em parceria com você.',
  },

  'en': {
    'nav.status': 'Accepting new partnerships',
    'nav.cta': 'Schedule a call',
    'hero.tag': 'Technology for creators',
    'hero.h1.a': 'We turn audiences',
    'hero.h1.em': 'into software.',
    'hero.lead': 'Hook identifies the SaaS opportunity in your niche, builds the product, and operates everything — in partnership with you.',
    'hero.cta': 'Schedule a discovery call',
    'hero.meta': '30 min · no commitment',
    'portfolio.label': 'Portfolio',
    'portfolio.h2.a': 'Products live,',
    'portfolio.h2.em': 'operating now.',
    'product.papomaterno.tag': 'Community and tools for mothers to track their journey, get answers, and share experiences.',
    'product.beluzi.tag': 'Wellness platform with daily rituals, guided practice, and ongoing support.',
    'product.personalburn.tag': 'Training, nutrition, and progress in one place — built with personal trainers, for personal trainers.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'Screenshot coming soon',
    'manifesto.label': 'How we work',
    'manifesto.h2.a': 'Partnership,',
    'manifesto.h2.em': 'not service.',
    'manifesto.body': 'Hook does not charge for development. We build the product, manage the infrastructure, and operate the SaaS alongside you — in exchange for 50% of the recurring revenue generated. We only win when you win.',
    'manifesto.body.strong': 'We build the product, manage the infrastructure, and operate the SaaS alongside you',
    'manifesto.sig': '— a Prisma Tech company, since 2022',
    'final.h2.a': 'The best products are born from the right combination of audience and',
    'final.h2.em': 'technology.',
    'final.body': 'If you have an engaged niche and want to understand if there\'s an opportunity here, we\'ll reserve 30 minutes for a conversation.',
    'final.cta': 'Schedule a call',
    'final.disclaimer': 'No commitment. No pitch.',
    'footer.tagline': 'A Prisma Tech company.',
    'footer.copy': '© hook',
    'meta.title': 'hook — We turn audiences into software',
    'meta.description': 'Hook identifies the SaaS opportunity in your niche, builds the product, and operates everything — in partnership with you.',
  },

  'es': {
    'nav.status': 'Aceptando nuevas asociaciones',
    'nav.cta': 'Agendar una llamada',
    'hero.tag': 'Tecnología para creadores',
    'hero.h1.a': 'Transformamos audiencias',
    'hero.h1.em': 'en software.',
    'hero.lead': 'Hook identifica la oportunidad de SaaS en tu nicho, construye el producto y opera todo — en asociación contigo.',
    'hero.cta': 'Agendar una llamada de discovery',
    'hero.meta': '30 min · sin compromiso',
    'portfolio.label': 'Portafolio',
    'portfolio.h2.a': 'Productos en vivo,',
    'portfolio.h2.em': 'operando ahora.',
    'product.papomaterno.tag': 'Comunidad y herramientas para que las madres acompañen su camino, resuelvan dudas y compartan experiencias.',
    'product.beluzi.tag': 'Plataforma de bienestar y rituales diarios, con práctica guiada y seguimiento continuo.',
    'product.personalburn.tag': 'Entrenamiento, nutrición y progreso en un solo lugar — construido con entrenadores personales, para entrenadores personales.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'Captura de pantalla próximamente',
    'manifesto.label': 'Cómo trabajamos',
    'manifesto.h2.a': 'Asociación,',
    'manifesto.h2.em': 'no servicio.',
    'manifesto.body': 'Hook no cobra por el desarrollo. Construimos el producto, gestionamos la infraestructura y operamos el SaaS junto contigo — a cambio del 50% de los ingresos recurrentes generados. Solo ganamos cuando tú ganas.',
    'manifesto.body.strong': 'Construimos el producto, gestionamos la infraestructura y operamos el SaaS junto contigo',
    'manifesto.sig': '— una empresa Prisma Tech, desde 2022',
    'final.h2.a': 'Los mejores productos nacen de la combinación correcta entre audiencia y',
    'final.h2.em': 'tecnología.',
    'final.body': 'Si tienes un nicho comprometido y quieres entender si existe una oportunidad aquí, reservamos 30 minutos para una conversación.',
    'final.cta': 'Agendar una llamada',
    'final.disclaimer': 'Sin compromiso. Sin pitch.',
    'footer.tagline': 'Una empresa Prisma Tech.',
    'footer.copy': '© hook',
    'meta.title': 'hook — Transformamos audiencias en software',
    'meta.description': 'Hook identifica la oportunidad de SaaS en tu nicho, construye el producto y opera todo — en asociación contigo.',
  },

  'fr': {
    'nav.status': 'Accepte de nouveaux partenariats',
    'nav.cta': 'Planifier un appel',
    'hero.tag': 'Technologie pour les créateurs',
    'hero.h1.a': 'Nous transformons les audiences',
    'hero.h1.em': 'en logiciels.',
    'hero.lead': 'Hook identifie l\'opportunité SaaS dans votre niche, construit le produit et gère tout — en partenariat avec vous.',
    'hero.cta': 'Planifier un appel de découverte',
    'hero.meta': '30 min · sans engagement',
    'portfolio.label': 'Portefeuille',
    'portfolio.h2.a': 'Produits en ligne,',
    'portfolio.h2.em': 'opérationnels maintenant.',
    'product.papomaterno.tag': 'Communauté et outils pour que les mères suivent leur parcours, obtiennent des réponses et partagent leurs expériences.',
    'product.beluzi.tag': 'Plateforme de bien-être avec des rituels quotidiens, pratique guidée et accompagnement continu.',
    'product.personalburn.tag': 'Entraînement, nutrition et progrès en un seul endroit — construit avec des coachs personnels, pour des coachs personnels.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'Capture d\'écran à venir',
    'manifesto.label': 'Comment nous travaillons',
    'manifesto.h2.a': 'Partenariat,',
    'manifesto.h2.em': 'pas service.',
    'manifesto.body': 'Hook ne facture pas pour le développement. Nous construisons le produit, gérons l\'infrastructure et opérons le SaaS avec vous — en échange de 50% des revenus récurrents générés. Nous ne gagnons que quand vous gagnez.',
    'manifesto.body.strong': 'Nous construisons le produit, gérons l\'infrastructure et opérons le SaaS avec vous',
    'manifesto.sig': '— une entreprise Prisma Tech, depuis 2022',
    'final.h2.a': 'Les meilleurs produits naissent de la bonne combinaison entre audience et',
    'final.h2.em': 'technologie.',
    'final.body': 'Si vous avez une niche engagée et voulez comprendre s\'il y a une opportunité ici, nous réservons 30 minutes pour une conversation.',
    'final.cta': 'Planifier un appel',
    'final.disclaimer': 'Sans engagement. Sans pitch.',
    'footer.tagline': 'Une entreprise Prisma Tech.',
    'footer.copy': '© hook',
    'meta.title': 'hook — Nous transformons les audiences en logiciels',
    'meta.description': 'Hook identifie l\'opportunité SaaS dans votre niche, construit le produit et gère tout — en partenariat avec vous.',
  },

  'zh': {
    'nav.status': '接受新的合作伙伴关系',
    'nav.cta': '预约通话',
    'hero.tag': '为创作者提供技术',
    'hero.h1.a': '我们将受众',
    'hero.h1.em': '转化为软件。',
    'hero.lead': 'Hook识别您所在细分市场的SaaS机会，构建产品并负责运营——与您携手合作。',
    'hero.cta': '预约探索通话',
    'hero.meta': '30分钟 · 无需承诺',
    'portfolio.label': '作品集',
    'portfolio.h2.a': '产品已上线，',
    'portfolio.h2.em': '正在运营。',
    'product.papomaterno.tag': '为母亲们提供社区和工具，帮助她们跟踪旅程、获取解答并分享经验。',
    'product.beluzi.tag': '健康平台，提供日常仪式、引导练习和持续支持。',
    'product.personalburn.tag': '训练、营养和进度集于一处——由私人教练为私人教练打造。',
    'product.link': 'usehook.net/app/',
    'product.placeholder': '截图即将推出',
    'manifesto.label': '我们的工作方式',
    'manifesto.h2.a': '合作，',
    'manifesto.h2.em': '而非服务。',
    'manifesto.body': 'Hook不收取开发费用。我们构建产品，管理基础设施，并与您共同运营SaaS——以换取产生的经常性收入的50%。只有当您获胜时，我们才获胜。',
    'manifesto.body.strong': '我们构建产品，管理基础设施，并与您共同运营SaaS',
    'manifesto.sig': '——Prisma Tech旗下公司，自2022年起',
    'final.h2.a': '最好的产品诞生于受众与',
    'final.h2.em': '技术的完美结合。',
    'final.body': '如果您拥有高参与度的细分市场，并想了解这里是否存在机会，我们将预留30分钟进行对话。',
    'final.cta': '预约通话',
    'final.disclaimer': '无需承诺。无需推销。',
    'footer.tagline': 'Prisma Tech旗下公司。',
    'footer.copy': '© hook',
    'meta.title': 'hook — 我们将受众转化为软件',
    'meta.description': 'Hook识别您所在细分市场的SaaS机会，构建产品并负责运营——与您携手合作。',
  },

  'hi': {
    'nav.status': 'नई साझेदारी स्वीकार कर रहे हैं',
    'nav.cta': 'कॉल शेड्यूल करें',
    'hero.tag': 'क्रिएटर्स के लिए तकनीक',
    'hero.h1.a': 'हम ऑडियंस को',
    'hero.h1.em': 'सॉफ्टवेयर में बदलते हैं।',
    'hero.lead': 'Hook आपके नीच में SaaS अवसर की पहचान करता है, प्रोडक्ट बनाता है और सब कुछ संचालित करता है — आपके साथ साझेदारी में।',
    'hero.cta': 'डिस्कवरी कॉल शेड्यूल करें',
    'hero.meta': '30 मिनट · कोई प्रतिबद्धता नहीं',
    'portfolio.label': 'पोर्टफोलियो',
    'portfolio.h2.a': 'प्रोडक्ट लाइव हैं,',
    'portfolio.h2.em': 'अभी चल रहे हैं।',
    'product.papomaterno.tag': 'माताओं के लिए समुदाय और उपकरण — यात्रा ट्रैक करने, प्रश्नों के उत्तर पाने और अनुभव साझा करने के लिए।',
    'product.beluzi.tag': 'वेलनेस प्लेटफॉर्म जिसमें दैनिक अनुष्ठान, गाइडेड प्रैक्टिस और निरंतर सहायता है।',
    'product.personalburn.tag': 'प्रशिक्षण, पोषण और प्रगति एक जगह — पर्सनल ट्रेनर्स द्वारा, पर्सनल ट्रेनर्स के लिए बनाया गया।',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'स्क्रीनशॉट जल्द आएगा',
    'manifesto.label': 'हम कैसे काम करते हैं',
    'manifesto.h2.a': 'साझेदारी,',
    'manifesto.h2.em': 'सेवा नहीं।',
    'manifesto.body': 'Hook विकास के लिए शुल्क नहीं लेता। हम प्रोडक्ट बनाते हैं, इंफ्रास्ट्रक्चर संभालते हैं और आपके साथ SaaS संचालित करते हैं — उत्पन्न आवर्ती राजस्व के 50% के बदले। हम तभी जीतते हैं जब आप जीतते हैं।',
    'manifesto.body.strong': 'हम प्रोडक्ट बनाते हैं, इंफ्रास्ट्रक्चर संभालते हैं और आपके साथ SaaS संचालित करते हैं',
    'manifesto.sig': '— एक Prisma Tech कंपनी, 2022 से',
    'final.h2.a': 'सबसे अच्छे प्रोडक्ट ऑडियंस और',
    'final.h2.em': 'तकनीक के सही संयोजन से जन्म लेते हैं।',
    'final.body': 'अगर आपके पास एक एंगेज्ड नीच है और आप जानना चाहते हैं कि यहाँ कोई अवसर है, तो हम बातचीत के लिए 30 मिनट आरक्षित करते हैं।',
    'final.cta': 'कॉल शेड्यूल करें',
    'final.disclaimer': 'कोई प्रतिबद्धता नहीं। कोई पिच नहीं।',
    'footer.tagline': 'एक Prisma Tech कंपनी।',
    'footer.copy': '© hook',
    'meta.title': 'hook — हम ऑडियंस को सॉफ्टवेयर में बदलते हैं',
    'meta.description': 'Hook आपके नीच में SaaS अवसर की पहचान करता है, प्रोडक्ट बनाता है और सब कुछ संचालित करता है — आपके साथ साझेदारी में।',
  },

  'ar': {
    'nav.status': 'نقبل شراكات جديدة',
    'nav.cta': 'جدولة مكالمة',
    'hero.tag': 'تكنولوجيا للمبدعين',
    'hero.h1.a': 'نحوّل الجماهير',
    'hero.h1.em': 'إلى برمجيات.',
    'hero.lead': 'تحدد Hook فرصة SaaS في مجال تخصصك، وتبني المنتج وتدير كل شيء — بالشراكة معك.',
    'hero.cta': 'جدولة مكالمة استكشافية',
    'hero.meta': '٣٠ دقيقة · بدون التزام',
    'portfolio.label': 'المحفظة',
    'portfolio.h2.a': 'منتجات مباشرة،',
    'portfolio.h2.em': 'تعمل الآن.',
    'product.papomaterno.tag': 'مجتمع وأدوات للأمهات لتتبع رحلتهن والحصول على إجابات ومشاركة التجارب.',
    'product.beluzi.tag': 'منصة للعافية مع طقوس يومية وممارسة موجهة ودعم مستمر.',
    'product.personalburn.tag': 'التدريب والتغذية والتقدم في مكان واحد — مبني مع المدربين الشخصيين، للمدربين الشخصيين.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'لقطة الشاشة قريباً',
    'manifesto.label': 'كيف نعمل',
    'manifesto.h2.a': 'شراكة،',
    'manifesto.h2.em': 'لا خدمة.',
    'manifesto.body': 'لا تفرض Hook رسوماً على التطوير. نبني المنتج ونديره ونشغل SaaS جنباً إلى جنب معك — مقابل 50٪ من الإيرادات المتكررة المتولدة. نحن نفوز فقط عندما تفوز أنت.',
    'manifesto.body.strong': 'نبني المنتج ونديره ونشغل SaaS جنباً إلى جنب معك',
    'manifesto.sig': '— شركة Prisma Tech، منذ 2022',
    'final.h2.a': 'أفضل المنتجات تولد من التوليفة الصحيحة بين الجمهور و',
    'final.h2.em': 'التكنولوجيا.',
    'final.body': 'إذا كان لديك مجال متخصص متفاعل وتريد فهم ما إذا كانت هناك فرصة هنا، سنحجز 30 دقيقة لمحادثة.',
    'final.cta': 'جدولة مكالمة',
    'final.disclaimer': 'بدون التزام. بدون عرض.',
    'footer.tagline': 'شركة Prisma Tech.',
    'footer.copy': '© hook',
    'meta.title': 'hook — نحوّل الجماهير إلى برمجيات',
    'meta.description': 'تحدد Hook فرصة SaaS في مجال تخصصك، وتبني المنتج وتدير كل شيء — بالشراكة معك.',
  },

  'bn': {
    'nav.status': 'নতুন অংশীদারিত্ব গ্রহণ করছি',
    'nav.cta': 'কল শিডিউল করুন',
    'hero.tag': 'ক্রিয়েটরদের জন্য প্রযুক্তি',
    'hero.h1.a': 'আমরা দর্শকদের',
    'hero.h1.em': 'সফটওয়্যারে রূপান্তরিত করি।',
    'hero.lead': 'Hook আপনার নিশে SaaS সুযোগ চিহ্নিত করে, পণ্য তৈরি করে এবং সবকিছু পরিচালনা করে — আপনার সাথে অংশীদারিত্বে।',
    'hero.cta': 'ডিসকভারি কল শিডিউল করুন',
    'hero.meta': '৩০ মিনিট · কোনো প্রতিশ্রুতি নেই',
    'portfolio.label': 'পোর্টফোলিও',
    'portfolio.h2.a': 'পণ্যগুলি লাইভ,',
    'portfolio.h2.em': 'এখন চলছে।',
    'product.papomaterno.tag': 'মায়েদের জন্য কমিউনিটি ও টুলস — যাত্রা ট্র্যাক করতে, প্রশ্নের উত্তর পেতে এবং অভিজ্ঞতা শেয়ার করতে।',
    'product.beluzi.tag': 'ওয়েলনেস প্ল্যাটফর্ম যেখানে দৈনিক রিচুয়াল, গাইডেড প্র্যাকটিস এবং অবিরাম সহায়তা রয়েছে।',
    'product.personalburn.tag': 'প্রশিক্ষণ, পুষ্টি এবং অগ্রগতি এক জায়গায় — পার্সোনাল ট্রেইনারদের দ্বারা, পার্সোনাল ট্রেইনারদের জন্য তৈরি।',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'স্ক্রিনশট শীঘ্রই আসছে',
    'manifesto.label': 'আমরা কীভাবে কাজ করি',
    'manifesto.h2.a': 'অংশীদারিত্ব,',
    'manifesto.h2.em': 'সেবা নয়।',
    'manifesto.body': 'Hook ডেভেলপমেন্টের জন্য চার্জ করে না। আমরা পণ্য তৈরি করি, অবকাঠামো পরিচালনা করি এবং আপনার সাথে SaaS পরিচালনা করি — উৎপন্ন আবর্তক রাজস্বের ৫০% এর বিনিময়ে। আমরা কেবল তখনই জিতি যখন আপনি জেতেন।',
    'manifesto.body.strong': 'আমরা পণ্য তৈরি করি, অবকাঠামো পরিচালনা করি এবং আপনার সাথে SaaS পরিচালনা করি',
    'manifesto.sig': '— একটি Prisma Tech কোম্পানি, ২০২২ সাল থেকে',
    'final.h2.a': 'সেরা পণ্যগুলি দর্শক এবং',
    'final.h2.em': 'প্রযুক্তির সঠিক সমন্বয় থেকে জন্ম নেয়।',
    'final.body': 'যদি আপনার একটি এনগেজড নিশ থাকে এবং এখানে কোনো সুযোগ আছে কিনা তা বুঝতে চান, আমরা একটি কথোপকথনের জন্য ৩০ মিনিট সংরক্ষণ করব।',
    'final.cta': 'কল শিডিউল করুন',
    'final.disclaimer': 'কোনো প্রতিশ্রুতি নেই। কোনো পিচ নেই।',
    'footer.tagline': 'একটি Prisma Tech কোম্পানি।',
    'footer.copy': '© hook',
    'meta.title': 'hook — আমরা দর্শকদের সফটওয়্যারে রূপান্তরিত করি',
    'meta.description': 'Hook আপনার নিশে SaaS সুযোগ চিহ্নিত করে, পণ্য তৈরি করে এবং সবকিছু পরিচালনা করে — আপনার সাথে অংশীদারিত্বে।',
  },

  'ru': {
    'nav.status': 'Принимаем новые партнёрства',
    'nav.cta': 'Запланировать звонок',
    'hero.tag': 'Технологии для создателей',
    'hero.h1.a': 'Мы превращаем аудиторию',
    'hero.h1.em': 'в программное обеспечение.',
    'hero.lead': 'Hook выявляет возможность SaaS в вашей нише, создаёт продукт и управляет всем — в партнёрстве с вами.',
    'hero.cta': 'Запланировать discovery-звонок',
    'hero.meta': '30 мин · без обязательств',
    'portfolio.label': 'Портфолио',
    'portfolio.h2.a': 'Продукты запущены,',
    'portfolio.h2.em': 'работают сейчас.',
    'product.papomaterno.tag': 'Сообщество и инструменты для мам — отслеживать свой путь, получать ответы и делиться опытом.',
    'product.beluzi.tag': 'Велнес-платформа с ежедневными ритуалами, guided-практикой и постоянной поддержкой.',
    'product.personalburn.tag': 'Тренировки, питание и прогресс в одном месте — создано с персональными тренерами, для персональных тренеров.',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'Скриншот скоро будет',
    'manifesto.label': 'Как мы работаем',
    'manifesto.h2.a': 'Партнёрство,',
    'manifesto.h2.em': 'не сервис.',
    'manifesto.body': 'Hook не берёт плату за разработку. Мы создаём продукт, управляем инфраструктурой и эксплуатируем SaaS вместе с вами — в обмен на 50% от генерируемого периодического дохода. Мы побеждаем только тогда, когда побеждаете вы.',
    'manifesto.body.strong': 'Мы создаём продукт, управляем инфраструктурой и эксплуатируем SaaS вместе с вами',
    'manifesto.sig': '— компания Prisma Tech, с 2022 года',
    'final.h2.a': 'Лучшие продукты рождаются из правильного сочетания аудитории и',
    'final.h2.em': 'технологий.',
    'final.body': 'Если у вас есть вовлечённая ниша и вы хотите понять, есть ли здесь возможность, мы зарезервируем 30 минут для разговора.',
    'final.cta': 'Запланировать звонок',
    'final.disclaimer': 'Без обязательств. Без питча.',
    'footer.tagline': 'Компания Prisma Tech.',
    'footer.copy': '© hook',
    'meta.title': 'hook — Мы превращаем аудиторию в программное обеспечение',
    'meta.description': 'Hook выявляет возможность SaaS в вашей нише, создаёт продукт и управляет всем — в партнёрстве с вами.',
  },

  'ja': {
    'nav.status': '新しいパートナーシップを募集中',
    'nav.cta': '通話を予約する',
    'hero.tag': 'クリエイターのためのテクノロジー',
    'hero.h1.a': '私たちはオーディエンスを',
    'hero.h1.em': 'ソフトウェアに変えます。',
    'hero.lead': 'Hookはあなたのニッチ市場のSaaS機会を特定し、プロダクトを構築し、すべてを運営します — あなたとのパートナーシップのもとで。',
    'hero.cta': 'ディスカバリーコールを予約する',
    'hero.meta': '30分 · コミットメント不要',
    'portfolio.label': 'ポートフォリオ',
    'portfolio.h2.a': 'プロダクトは公開中、',
    'portfolio.h2.em': '今まさに稼働しています。',
    'product.papomaterno.tag': '母親たちが旅を追跡し、疑問を解消し、経験を共有するためのコミュニティとツール。',
    'product.beluzi.tag': 'デイリーリチュアル、ガイド付きプラクティス、継続的なサポートを備えたウェルネスプラットフォーム。',
    'product.personalburn.tag': 'トレーニング、栄養、進捗を一か所に — パーソナルトレーナーによる、パーソナルトレーナーのためのプラットフォーム。',
    'product.link': 'usehook.net/app/',
    'product.placeholder': 'スクリーンショットは近日公開',
    'manifesto.label': '私たちの働き方',
    'manifesto.h2.a': 'パートナーシップ、',
    'manifesto.h2.em': 'サービスではなく。',
    'manifesto.body': 'Hookは開発費を請求しません。私たちはプロダクトを構築し、インフラを管理し、あなたと共にSaaSを運営します — 生成される定期収益の50%と引き換えに。私たちはあなたが勝ったときにのみ勝ちます。',
    'manifesto.body.strong': '私たちはプロダクトを構築し、インフラを管理し、あなたと共にSaaSを運営します',
    'manifesto.sig': '— Prisma Tech社、2022年から',
    'final.h2.a': '最高のプロダクトはオーディエンスと',
    'final.h2.em': 'テクノロジーの正しい組み合わせから生まれます。',
    'final.body': 'エンゲージされたニッチをお持ちで、ここに機会があるかを知りたい場合は、30分間の会話をご予約ください。',
    'final.cta': '通話を予約する',
    'final.disclaimer': 'コミットメント不要。ピッチなし。',
    'footer.tagline': 'Prisma Tech社。',
    'footer.copy': '© hook',
    'meta.title': 'hook — 私たちはオーディエンスをソフトウェアに変えます',
    'meta.description': 'Hookはあなたのニッチ市場のSaaS機会を特定し、プロダクトを構築し、すべてを運営します — あなたとのパートナーシップのもとで。',
  },
} satisfies Record<Locale, Record<string, string>>;

export type TranslationKey = keyof typeof ui[typeof defaultLocale];
export type Translator = (key: TranslationKey | string) => string;

export function useTranslations(locale: Locale): Translator {
  return function t(key) {
    const dict = ui[locale] as Record<string, string>;
    const fallback = ui[defaultLocale] as Record<string, string>;
    return dict[key] ?? fallback[key] ?? key;
  };
}

export function getLocalePath(locale: Locale, path = ''): string {
  if (locale === defaultLocale) return `/${path}`;
  return `/${locale}${path ? '/' + path : ''}`;
}
